module.exports = function({ addUtilities, theme }) {
  addUtilities(
    {
      '.squish-quark': { padding: `${theme('spacing.quark')} ${theme('spacing.nano')}` },
      '.squish-nano': { padding: `${theme('spacing.nano')} ${theme('spacing.xxxs')}` },
      '.squish-xxxs': { padding: `${theme('spacing.xxxs')} ${theme('spacing.xxs')}` },
      '.squish-xxs': { padding: `${theme('spacing.xxs')} ${theme('spacing.xs')}` },
      '.squish-xs': { padding: `${theme('spacing.xs')} ${theme('spacing.sm')}` },
      '.squish-sm': { padding: `${theme('spacing.sm')} ${theme('spacing.md')}` },
      '.squish-md': { padding: `${theme('spacing.md')} ${theme('spacing.lg')}` },

      '.stretch-quark': { padding: `${theme('spacing.nano')} ${theme('spacing.quark')}` },
      '.stretch-nano': { padding: `${theme('spacing.xxxs')} ${theme('spacing.nano')}` },
      '.stretch-xxxs': { padding: `${theme('spacing.xxs')} ${theme('spacing.xxxs')}` },
      '.stretch-xxs': { padding: `${theme('spacing.xs')} ${theme('spacing.xxs')}` },
      '.stretch-xs': { padding: `${theme('spacing.sm')} ${theme('spacing.xs')}` },
      '.stretch-sm': { padding: `${theme('spacing.md')} ${theme('spacing.sm')}` },
      '.stretch-md': { padding: `${theme('spacing.lg')} ${theme('spacing.md')}` },
    },
    ['responsive']
  );
};
